<template>
  <el-dialog
    @open="onOpen"
    :title="tituloDialog"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="40%"
  >
    <el-form
      ref="form"
      :model="conta"
      :rules="validacao"
      hide-required-asterisk
      :show-message="false"
      size="small"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item prop="status" label="Status">
            <el-select
              v-model="conta.status"
              value-key="data"
              placeholder=""
              style="width: 100%"
            >
              <el-option 
                v-for="item in statusConta"
                :key="item.data"
                :value="item.data"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="9">
          <el-form-item prop="tipo" label="Tipo">
            <el-select
              v-model="conta.tipo"
              value-key="data"
              placeholder=""
              style="width: 100%"
            >
              <el-option
                v-for="item in tiposConta"
                :key="item.data"
                :value="item.data"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="9">
          <el-form-item prop="banco" label="Banco">
            <el-select
              v-model="conta.banco"
              value-key="data"
              placeholder=""
              filterable
              default-first-option
              style="width: 100%"
            >
              <el-option
                v-for="item in bancos"
                :key="item.data"
                :value="item.data"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="10">
        <el-form-item prop="titular" label="Titular">
          <el-input v-model="conta.titular" />
        </el-form-item>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item prop="agencia" label="Agência">
            <el-input v-model="conta.agencia" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Díg.">
            <el-input v-model="conta.digitoAgencia" maxlength="1" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="conta" label="Conta">
            <el-input v-model="conta.conta" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Díg.">
            <el-input v-model="conta.digitoConta" maxlength="1" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Operação">
            <el-input v-model="conta.operacao" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-form-item label="Observação">
          <el-input
            v-model="conta.observacao"
            type="textarea"
            resize="none"
            :autosize="{minRows: 8}"
          />
        </el-form-item>
      </el-row>
    </el-form>
    
    <span slot="footer">
      <el-row type="flex" justify="end">
        <el-button
          @click="gravarHandler"
          type="success"
          size="small"
          round
          class="btn-box-shadow"
        >
          Gravar
        </el-button>

        <el-button
          @click="fechar"
          type="danger"
          size="small"
          round
          class="btn-box-shadow"
        >
          Fechar
        </el-button>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { STATUS_CONTA, TIPO_CONTA, BANCOS } from '../../../util/constantes.js'

export default {
  props: {
    visibility: Boolean,
    contaASerAlterada: Object
  },
  data() {
    return {
      validacao: {
        status: [
          { required: true, message: "Status é obrigatório" }
        ],
        tipo: [
          { required: true, message: "Tipo é obrigatório" }
        ],
        banco: [
          { required: true, message: "Banco é obrigatório" }
        ],
        titular: [
          { required: true, message: "Titular é obrigatório" }
        ],
        agencia: [
          { required: true, message: "Agência é obrigatório" }
        ],
        conta: [
          { required: true, message: "Conta é obrigatório" }
        ]
      },
      conta: {
        id: 0,
        status: '',
        tipo: '',
        banco: '',
        titular: '',
        agencia: '',
        digitoAgencia: '',
        conta: '',
        digitoConta: '',
        operacao: '',
        observacao: '',
        usuario: { id: 0 }
      }
    }
  },
  computed: {
    ...mapState('usuariosStore', {
      usuario(state) { return state.usuarioSelecionado }
    }),
    statusConta() { return STATUS_CONTA },
    tiposConta() { return TIPO_CONTA },
    bancos() { return BANCOS },
    isCriacao() {
      return this.contaASerAlterada === undefined;
    },
    tituloDialog() {
      if(this.isCriacao) return 'Nova Conta Bancária';
      else return 'Editar Conta Bancária';
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('usuariosStore', [
      'gravarConta'
    ]),
    onOpen() {
      this.verificarAlteracao();
    },
    reset() {
      this.conta = {
        id: 0,
        status: '',
        tipo: '',
        banco: '',
        titular: '',
        agencia: '',
        digitoAgencia: '',
        conta: '',
        digitoConta: '',
        operacao: '',
        observacao: '',
        usuario: { id: 0 }
      };
      this.$refs.form.resetFields();
    },
    fechar() {
      this.reset();
      this.$emit('close');
    },
    gravarHandler() {
      this.$refs['form'].validate(this.validarFormularioEGravar);
    },
    validarFormularioEGravar(formularioIsValido) {
      const formularioInvalido = !formularioIsValido;
      if(formularioInvalido) {
        this.$message.warning("Preencha todos os campos obrigatórios");
        return;
      }
      
      this.gravar();
    },
    gravar() {
      this.preencherUsuario();
      this.showLoading();
      this.gravarConta(this.conta).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    preencherUsuario() {
      this.conta.usuario = { id: this.usuario.id };
    },
    verificarAlteracao() {
      const isAlteracao = this.contaASerAlterada !== undefined;
      if(isAlteracao) {
        this.conta = Object.assign({}, this.contaASerAlterada);
      }
    }
  }
}
</script>